import { OrdersList } from '@components/orders/OrdersList'

export default function Orders() {
  return <OrdersList />
}
